module.exports = __webpack_public_path__ + "static/media/pragmaticpeugeot.a4f21703.webp";